const localStorageClientIdKey = 'onvio.documents.treeNavigation.clientId';
const localStorageTreeCollapsedKey = 'onvio.documents.treeNavigation.treeCollapsed';
const localStorageTreePaneWidthKey = 'onvio.documents.treeNavigation.treePaneWidth';

function arrayChanged(a: Array<any>, b: Array<any>): boolean {
    return (a.length !== b.length) || a.some((el, i) => el.id !== b[i].id);
}

function valueIfDefined(value: any, fallback: any) {
    return (value === undefined) ? fallback : value;
}

enum ProjectGroupBy {
	None = 'None',
	Year = 'Year',
	App = 'App',
	YearThenApp = 'YearThenApp',
	AppThenYear = 'AppThenYear',
}

enum FileDrawer {
	Client = 'Client',
	My = 'My',
	Firm = 'Firm',
	All = 'All',
}

enum ItemType {
	Project = 'PROJECT',
	Folder = 'FOLDER',
	Document = 'DOCUMENT',
	Link = 'LINK',
	Client = 'CLIENT',
	Template = 'TEMPLATE',
	AppGroup = 'APP_GROUP',
	YearGroup = 'YEAR_GROUP',
	Trash = 'TRASH',
}

type ContainerType = ItemType.AppGroup | ItemType.Client | ItemType.Folder | ItemType.Project | ItemType.Template | ItemType.Trash | ItemType.YearGroup;

type StateName = "TreeViewDocumentInRoot" | "TreeView" | "TreeViewInDocument" | "TreeViewInContainer";

interface BentoAlertItemOptions {
	msg?: string;
	type?: string;
	closeable?: boolean;
	timeout?: number;
	closeButtonLabel?: string;
}

interface ITreeViewScope extends ng.IScope {
    container: ItemKey;
	alerts: BentoAlertItemOptions[];
    finalizationFunctionContainer: any;
}

interface IProjectGroupingUserOptions {
	groupProjectsBy: ProjectGroupBy;
}

interface IUserOptionsDto {
	id: string;
	contactId: string;
	companyId: string;
	application: string;
	category: string;
	preferences: string;
}


// tslint:disable-next-line: interface-name
interface ItemKey {
    id: string;
    type: ItemType;
}

interface ParentedItemKey extends ItemKey {
	parent: ContainerKey;
}

interface ContainerKey extends ItemKey {
	type: ContainerType;
}

// tslint:disable-next-line: interface-name
interface NavSelection {
    drawer: FileDrawer;
    drawerId?: string;
    container?: ItemKey;
    document?: ItemKey;
}

interface User {
	id: string;
	isCurrentUser: boolean;
	firstName?: string | undefined;
	lastName?: string | undefined;
	displayAs?: string | undefined;
}

interface ItemHistory {
	createdBy: User;
	createdDate: Date;
	modifiedBy: User;
	modifiedDate: Date;
}

interface Permissions {
	canCreate: boolean;
	canRead: boolean;
	canUpdate: boolean;
	canDelete: boolean;
	canMove: boolean;
}

interface ItemLock {
	type?: 'None' | 'Read' | 'Edit';
	level?: 'Ancestor' | 'Descendant' | 'Master';
	createdBy?: string;
	createdDate?: string;
	isContainer?: boolean;
	context?: string;
}

// tslint:disable-next-line: interface-name
interface Item extends ParentedItemKey {
	isContainer: boolean;
	name: string;
	history: ItemHistory;
	permissions: Permissions;
	isShared: boolean;
	customFields: Map<string, any>;
	lock?: ItemLock;
	legacyItem?: any;
	isReadByClientUser?: boolean;
    customItemMetaData?: Map<string, any>;
}

// tslint:disable-next-line: interface-name
interface ItemCollection {
    items: ReadonlyArray<Item>;
}

// tslint:disable-next-line: interface-name
interface ToolbarButtonEvent {
	buttonId: string;
	selection: NavSelection;
	items: ItemCollection;
}

interface ToolbarContainer {
	itemType: 'Client' | 'Folder' | 'Project';
	id: string;
}

interface ISelectedState {
    drawer?: FileDrawer | null;
    drawerId?: string;
    containerId?: string;
    containerType?: ItemType;
    documentId?: string;
    document?: 'document' | null;
}

/** Legacy ToolbarButtonDepot button's action function 'container' parameter type definition */
interface ILegacyContainer {
    id: string;
    itemType: string;
    containerType: string;
}

interface DmsModels {
	toItemType(type: string): ItemType;
}

interface ItemStore {
	observeItems(keys: Array<ItemKey>): Rx.Observable<Array<Item>>;
}

interface TreeStore {
	observeChildrenKeys(key: ContainerKey): Rx.Observable<Array<ItemKey>>;
	updateChildren(key: ContainerKey): Promise<Array<Item>>;
}

interface DmsUserOptionsService {
	getUserOptions(contactId: string): Promise<IUserOptionsDto>;
	getGroupProjectsBy(userOptions: IUserOptionsDto): ProjectGroupBy;
}

(function(angular: ng.IAngularStatic) {
    'use strict';

    var inject = [
        '$state',
        '$scope',
        '$rootScope',
        '$window',
        '$element',
        '$translate',
        '$q',
        'dmsModels',
        'dmsItemStore',
        'treeNavRouteModel',
        'dmsTreeStore',
        'dmsAccess',
        'dmsPermission',
        'dmsUserOptionsService',
        'bmUser',
        'dmsToolbarButtonDepot',
        'dmsStateChangeHookService',
        'dmsApprovalModalService',
        'dmsSendDocumentsModalService',
        'dmsCopyFolderSelectionModalService',
        'dmsMoveFolderSelectionModalService',
        'fileManager',
        'dmsRenameFileService',
        'dmsRecycleBinUiService',
        'dmsUnlockDocumentService',
        'DmsCancellationTokenSourceFactory',
        'DmsPollerFactory',
    ];

    class TreeViewController {

        constructor(
            private $state: any,
            private $scope: ITreeViewScope,
            private $rootScope: ng.IRootScopeService,
            private $window: ng.IWindowService,
            private $element: ng.IRootElementService,
            private $translate: any,
            private $q: ng.IQService,
            private dmsModels: DmsModels,
            private dmsItemStore: ItemStore,
            private treeNavRouteModel: any,
            private dmsTreeStore: TreeStore,
            private dmsAccess: any,
            private dmsPermission: any,
            private dmsUserOptionsService: DmsUserOptionsService,
            private bmUser: any,
            private dmsToolbarButtonDepot: any,
            private dmsStateChangeHookService: any,
            private dmsApprovalModalService: unknown,
            private dmsSendDocumentsModalService: unknown,
            private dmsCopyFolderSelectionModalService: unknown,
            private dmsMoveFolderSelectionModalService: unknown,
            private fileManager: unknown,
            private dmsRenameFileService: unknown,
            private dmsRecycleBinUiService: unknown,
            private dmsUnlockDocumentService: unknown,
            private dmsCancellationTokenSourceFactory: unknown,
            private dmsPollerFactory: unknown,
        ) {
            // Fix binding of functions passed by reference in template
            this.getHref = this.getHref.bind(this);
            this.getHrefForItem = this.getHrefForItem.bind(this);
            this.closePreview = this.closePreview.bind(this);

            this.toolbarServicesFacade = {
                $q: this.$q,
                dmsApprovalModalService: this.dmsApprovalModalService,
                dmsSendDocumentsModalService: this.dmsSendDocumentsModalService,
                dmsCopyFolderSelectionModalService: this.dmsCopyFolderSelectionModalService,
                dmsMoveFolderSelectionModalService: this.dmsMoveFolderSelectionModalService,
                fileManager: this.fileManager,
                dmsRenameFileService: this.dmsRenameFileService,
                dmsModels: this.dmsModels,
                dmsTreeStore: this.dmsTreeStore,
                dmsRecycleBinUiService: this.dmsRecycleBinUiService,
                dmsUnlockDocumentService: this.dmsUnlockDocumentService,
                dmsCancellationTokenSourceFactory: this.dmsCancellationTokenSourceFactory,
                dmsPollerFactory: this.dmsPollerFactory,
                eventTrigger: (eventName: string) => { this.$rootScope.$broadcast(eventName); }
            };
        }

        toolbarServicesFacade: any;
        subscriptions: any[] = [];
        viewerInitialized = false;
        finalizationFunctionContainer: any = null;
        previewDocs: Item[] = [];
        previewCurrentIndex = 0;
        previousDocId = '';
        toolbarContainer: ToolbarContainer = null;
        isLeftCollapsed = true;
        childItemSubscription: any = null;
        previousPreviewKeys: ItemKey[] = [];
        isRootFolder = true;
        showReadStateFilter = false;
        isCurrentDev = false;
        annotationsAllowed = false;
        selected: ISelectedState;
        previousSelected: ISelectedState;
        isClientDocuments = false;
        treePaneWidth: string;
        treePaneNumericWidth: string | number;
        navSelection: NavSelection;
        groupProjectsBy: ProjectGroupBy = ProjectGroupBy.None;
        showNewGrid = false;
        showDownloadModal = false;
        hideDocumentPreview = false;

        $onInit(): void {
            this.$scope.alerts = [];

            this.$scope.$watch('ctrl.selected.drawerId', (newValue: string, oldValue: string) => {
                this.onDrawerIdChange(newValue, oldValue);
            }, true);

            this.$scope.$on('dmsTreeChangeSelection', (_: any, selection: ISelectedState) => {
                this.onSelectedChange(selection);
            });

            this.$scope.$on('$destroy', () => this.unsubscribeAll());

            this.$scope.$on(
                "dms-viewer-open-download-modal",
                (_: unknown, selected: any) => {
                    this.showDownloadModal = true;
                    this.hideDocumentPreview = true;
                    this.selected.documentId = selected.id;
                    this.setPreview();
                }
            );

            this.initSelected();
            this.isClientDocuments = this.selected.drawer === FileDrawer.Client;
            this.setToolbarContainer();
            this.restoreSettingsFromLocalStorage();
            this.setPreview();

            //update page title
            this.$scope.$emit('pageTitleUpdate', {
                itemType: 'TreeView',
                drawer: this.selected.drawer,
            });

            // restore these settings last because they are async/slow/require a network request
            this.restoreSettingsFromServer();
        }

        setCurrentPreviewIndex(): void {
            let currentItem;
            const key = { type: this.dmsModels.toItemType(this.selected.containerType), id: this.selected.containerId };
            // TODO: Remove `else` when IE11 support no longer needed
            if ((Array.prototype as any).find) {
                currentItem = (this.previewDocs).find((doc: Item) => doc.id === this.selected.documentId);
            } else {
                this.previewDocs.forEach(function(doc: Item) {
                    if (doc.id === this.selected.documentId) {
                        currentItem = doc;
                    }
                });
            }

            // Handles links to deleted documents
            if (!currentItem && this.previewDocs.length > 0) {
                this.dmsTreeStore.updateChildren(key as ContainerKey).then((childKeys) => {
                    if (this.selected.documentId) {
                        currentItem = childKeys.find((doc: Item) => doc.id === this.selected.documentId);
                        if (!currentItem) {
                            this.$scope.alerts.push({
                                msg: this.$translate.instant(/* i18nextract */'Bluemoon.DMS.Grid.Recycle.LocationUnavailable'),
                                type: 'danger',
                                closeable: true,
                                timeout: 4000,
                            });
                            this.selected.documentId = null;
                        }
                    }

                this.setState();
                this.setPreview();
                })
            }

            this.previewCurrentIndex = this.previewDocs.indexOf(currentItem);
            this.previousDocId = this.selected.documentId;
        }

        resizePreview(): void {
            const previewEl = this.$element[0].querySelector('app-file-preview');
            const offset = this.isLeftCollapsed ? 0 : parseInt(this.treePaneNumericWidth as string, 10);
            if (!!previewEl) {
                (previewEl as HTMLElement).style.width = 'calc(100% - ' + (offset + 55) + 'px)';
            }
        }

        setPreview(): void {
            if (this.selected.documentId && (!this.previousDocId || !this.previousSelected || this.selected.containerId !== this.previousSelected.containerId)) {
                this.unsubscribeAll();
                const key = { type: this.dmsModels.toItemType(this.selected.containerType), id: this.selected.containerId };
                this.subscriptions.push(this.dmsTreeStore.observeChildrenKeys(key as ContainerKey).subscribe((childKeys: Array<ItemKey>) => {
                    const childrenChanged = arrayChanged(this.previousPreviewKeys, childKeys);
                    if (childrenChanged) {
                        this.previousPreviewKeys = childKeys;
                        if (this.childItemSubscription) {
                            this.childItemSubscription.unsubscribe();
                        }
                        const docsKeys = childKeys.filter((child: ItemKey) => child.type === ItemType.Document);
                        this.childItemSubscription = this.dmsItemStore.observeItems(docsKeys).subscribe((documents: Item[]) => {
                            const docsChanged = arrayChanged(this.previewDocs, documents);
                            if (docsChanged) {
                                this.previewDocs = documents;
                                this.viewerInitialized = true;
                                this.finalizationFunctionContainer = this.dmsStateChangeHookService.createStateChangeHookContainer();
                                this.setCurrentPreviewIndex();
                                this.resizePreview();
                            }
                        });
                        this.subscriptions.push(this.childItemSubscription);
                    } else {
                        this.setCurrentPreviewIndex();
                    }

                }));


                this.previousSelected = this.selected;
            } else if (this.selected.documentId && this.previousDocId !== this.selected.documentId) {
                this.setCurrentPreviewIndex();
            } else if (!this.selected.documentId) {
                this.unsubscribeAll();
                this.previewDocs = [];
                this.previousDocId = '';
                this.previousSelected = this.selected;
                this.previousPreviewKeys = [];
            }
        }

        getHref(selected: ISelectedState): string {
            if (selected.documentId) {
                selected.document = 'document';
            }
            return this.$state.href(this.getStateName(selected), selected, { absolute: true });
        }

        onGridRowClicked(item: any): void {
            this.onSelectedChange(this.itemToSelected(item));
        }

        onToolbarButtonClicked(event: ToolbarButtonEvent): void {
            if (event.buttonId === 'shareFolder' || event.buttonId === 'shareEditLink') {
                this.onShareButtonClicked(event);
            } else if (event.buttonId === 'upOneLevel') {
                this.onUpOneLevelButtonClicked(event);
            } else if (event.buttonId === 'dms-fe-legacy-components-client-documents-new-folder-button') {
                this.onAddFolderButtonClicked(event);
            } else if (event.buttonId === 'delete') {
                this.onDeleteButtonClicked(event);
            } else if (event.buttonId === 'properties') {
                this.onPropertiesButtonClicked(event);
            }
        }

        onShareButtonClicked(event: ToolbarButtonEvent): void {
            const legacyContainer: ILegacyContainer = {
                containerType: event.selection.container? event.selection.container.type : 'Client',
                id: event.selection.container? event.selection.container.id : this.selected.drawerId,
                itemType: event.selection.container? event.selection.container.type: 'Client',
            };
            // Container null check to identify if we're at client level and to leave parentItem blank if we are
            const selected = event.items.items.map(item => item.legacyItem);

            this.executeLegacyButtonAction('share', selected, legacyContainer);
        }

        onUpOneLevelButtonClicked(event: ToolbarButtonEvent): void {
            const legacyContainer: ILegacyContainer = {
                containerType: event.selection.container.type,
                id: event.selection.container.id,
                itemType: event.selection.container.type,
            };
            this.executeLegacyButtonAction('upOneLevel', undefined, legacyContainer);
        }

        onAddFolderButtonClicked(event: ToolbarButtonEvent): void {
            const legacyContainer: ILegacyContainer = {
                containerType: event.selection.container? event.selection.container.type : 'Client',
                id: event.selection.container? event.selection.container.id : this.selected.drawerId,
                itemType: event.selection.container? event.selection.container.type: 'Client',
            };

            this.executeLegacyButtonAction('newFolder', undefined, legacyContainer);
        }

        onDeleteButtonClicked(event: ToolbarButtonEvent): void {
            const legacyContainer = this.legacyContainerFromSelection(event.selection);
            const selected = event.items.items.map(item => item.legacyItem);
            this.executeLegacyButtonAction('remove', selected, legacyContainer);
        }

        onPropertiesButtonClicked(event: ToolbarButtonEvent): void {
            const items = event.items.items.map(item => item.legacyItem);
            this.executeLegacyButtonAction('projectProperties', items);
        }

        executeLegacyButtonAction(legacyButtonName:string, selected?: any[], container?: ILegacyContainer): void {
            this.dmsToolbarButtonDepot.get(legacyButtonName).action(
                selected,
                container,
                this.selected.drawerId, //clientId
                this.$scope);
        }

        getHrefForItem(item: any): string {
            return this.getHref(this.itemToSelected(item));
        }

        legacyContainerFromSelection(selection: NavSelection): ILegacyContainer {
            const key = {
                id: (selection.container && selection.container.id) || selection.drawerId,
                type: (selection.container && selection.container.type) || 'folder',
            };
            return {
                containerType: key.type + 's',
                id: key.id,
                itemType: key.type,
            };
        }

        itemToSelected(item: any): ISelectedState {
            const isContainer: boolean = item.isContainer;
            if (isContainer) {
                return {
                    ...this.selected,
                    containerId: item.id,
                    containerType: item.type,
                };
            } else {
                return {
                    ...this.selected,
                    documentId: item.id,
                    document: 'document',
                };
            }
        }

        unsubscribeAll(): void {
            this.subscriptions.forEach(function(s: any) {
                s.unsubscribe();
            });
        }

        drawerParamToSelectedDrawer(drawerParam: string): FileDrawer | null {
            if (drawerParam) {
                const dwParam = drawerParam.toLowerCase();
                if (dwParam === this.treeNavRouteModel.Client) {
                    return FileDrawer.Client;
                } else if (dwParam === this.treeNavRouteModel.My) {
                    return FileDrawer.My;
                } else if (dwParam === this.treeNavRouteModel.Firm) {
                    return FileDrawer.Firm;
                }
            }

            return null;
        }

        /**
         * Populates every property on the Selected object so that child components have all the info they need to make API calls
         */
        initSelected(): void {
            if (!this.selected) {
                this.selected = {};
            }
            const isRootOfMyOrFirm =
                (this.$state.params.drawer.toLowerCase() === this.treeNavRouteModel.My || this.$state.params.drawer.toLowerCase() === this.treeNavRouteModel.Firm) &&
                !this.$state.params.containerType &&
                !this.$state.params.containerId;

            // TODO: sanitize and redirect to not found page if url params are unexpected values
            // TODO: handle url casing as a ui-router config setting
            this.selected.drawer = this.drawerParamToSelectedDrawer(this.$state.params.drawer);
            this.selected.drawerId = this.$state.params.drawerId;
            this.selected.containerType = isRootOfMyOrFirm
                ? ItemType.Folder
                : (this.$state.params.containerType ?
                    this.dmsModels.toItemType(this.$state.params.containerType) : null);
            this.selected.containerId = isRootOfMyOrFirm ? this.$state.params.drawerId : this.$state.params.containerId;
            this.selected.documentId = this.$state.params.documentId;
            this.navSelection = this.selectedToNavSelection(this.selected);
            this.showNewGrid = this.shouldShowNewGrid();
        }

        async restoreSettingsFromServer(): Promise<void> {
            await this.bmUser.load();
            const userOptions = await this.dmsUserOptionsService.getUserOptions(this.bmUser.contactId);
            this.groupProjectsBy = this.dmsUserOptionsService.getGroupProjectsBy(userOptions);
            this.showNewGrid = this.shouldShowNewGrid();

            this.$scope.$evalAsync(async () => {
                this.showReadStateFilter = !await this.dmsAccess.has('DMS_HideViewedColumn');
            });
            this.$scope.$evalAsync(async () => {
                this.isCurrentDev = await this.dmsPermission.has('Internal.CurrentDevelopment');
                this.annotationsAllowed = await this.dmsPermission.has('OnvioDrive.Annotations');
            });
        }

        async restoreSettingsFromLocalStorage(): Promise<void> {
            var treePaneWidth = this.$window.localStorage.getItem(localStorageTreePaneWidthKey);
            if (treePaneWidth !== null) {
                this.treePaneWidth = treePaneWidth + 'px';
                this.treePaneNumericWidth = treePaneWidth;
            } else {
                this.treePaneWidth = '300px';
                this.treePaneNumericWidth = 300;
            }
            var savedCollapsedState = this.$window.localStorage.getItem(localStorageTreeCollapsedKey);
            if (savedCollapsedState !== null) {
                this.isLeftCollapsed = (savedCollapsedState === 'true');
                this.treePaneNumericWidth = savedCollapsedState === 'true' ? 55 : this.treePaneNumericWidth;
            } else {
                this.isLeftCollapsed = false;
            }

            if (this.isClientDocuments && this.selected.drawerId) {
                this.$window.localStorage.setItem(localStorageClientIdKey, this.selected.drawerId);
            } else if (this.isClientDocuments && !this.selected.drawerId) {
                this.selected.drawerId = this.$window.localStorage.getItem(localStorageClientIdKey);
                this.setState();
            } else {
                // My/Firm Documents Tab
                this.setState();
            }
            this.resizePreview();
        }

        onSplitterResize(): void {
            this.$rootScope.$broadcast('dms-client-tree-nav-resize');
            this.treePaneNumericWidth = this.$element[0].querySelector('.bento-splitter-group-left').getBoundingClientRect().width;
            this.$window.localStorage.setItem(
                localStorageTreePaneWidthKey,
                String(this.treePaneNumericWidth));
            this.$window.localStorage.setItem(localStorageTreeCollapsedKey, String(this.isLeftCollapsed));
            this.resizePreview();
        }

        /**
         * @returns an object suitable for use by $state.go(), including nulling out values that should not appear in the address bar
         */
        treeNavRouteMapper(): ISelectedState {

            // set some state values to null so they don't appear in the URL/address bar
            const inRootOfMyOrFirm = (this.selected.drawer.toLowerCase() === this.treeNavRouteModel.My ||
                this.selected.drawer.toLowerCase() === this.treeNavRouteModel.Firm) &&
                this.selected.containerId === this.selected.drawerId;

            const selectedState: ISelectedState = {
                drawer: this.selected.drawer && this.selected.drawer.toLowerCase() as FileDrawer,
                drawerId: this.selected.drawerId,
                containerType: inRootOfMyOrFirm ? null : this.containerTypeToStateParam(this.selected.containerType) as ItemType,
                containerId: inRootOfMyOrFirm ? null : this.selected.containerId,
                documentId: this.selected.documentId,
                document: null as any,
            };

            if (this.selected.documentId) {
                selectedState.document = 'document';
            }

            return selectedState;
        }

        containerTypeToStateParam(type?: string): string | null {
            return !type ? null :
                (type === ItemType.AppGroup || type === ItemType.YearGroup) ? type :
                type.toLowerCase();
        }

        getStateName (selected: ISelectedState): StateName {
            const isRootOfMyOrFirm =
                (selected.drawer.toLowerCase() === this.treeNavRouteModel.My || selected.drawer.toLowerCase() === this.treeNavRouteModel.Firm) &&
                !selected.containerType &&
                !selected.containerId;

            if (isRootOfMyOrFirm && selected.documentId) {
                return 'TreeViewDocumentInRoot';
            }

            return isRootOfMyOrFirm ? 'TreeView' : (selected.documentId ? 'TreeViewInDocument' : 'TreeViewInContainer');
        }

        setState(setNavSelection:boolean = true): void {
            var selectedState = this.treeNavRouteMapper();
            if (setNavSelection) {
                this.navSelection = this.selectedToNavSelection(this.selected)
            }
            this.$state.go(this.getStateName(selectedState), selectedState, { notify: false });
            this.setToolbarContainer();
            this.showNewGrid = this.shouldShowNewGrid();
        }

        shouldShowNewGrid(): boolean {
            return this.selected.drawer === FileDrawer.Client && this.groupProjectsBy && this.groupProjectsBy !== ProjectGroupBy.None &&
                (!this.selected.containerType || this.selected.containerType === ItemType.AppGroup || this.selected.containerType === ItemType.YearGroup);
        }

        onDrawerIdChange(newValue: string, oldValue: string): void {
            if (newValue !== oldValue) {
                this.selected = {
                    drawerId: this.selected.drawerId,
                    containerType: null,
                    containerId: null,
                    documentId: null,
                    drawer: this.drawerParamToSelectedDrawer(this.selected.drawer),
                };

                this.setToolbarContainer();

                if (this.selected.drawer === FileDrawer.Client) {
                    this.$window.localStorage.setItem(localStorageClientIdKey, this.selected.drawerId);
                }

                this.setPreview();
                this.setState();
            }
        }

        /* Called when client is selected in tree or grid */
        onSelectedChange(newValue?: ISelectedState): void {
            if (newValue) {
                this.selected = {
                    drawer: valueIfDefined(newValue.drawer, this.selected.drawer),
                    drawerId: valueIfDefined(newValue.drawerId, this.selected.drawerId),
                    containerType: newValue.containerType && this.dmsModels.toItemType(newValue.containerType),
                    containerId: newValue.containerId,
                    documentId: newValue.documentId,
                };

                this.setPreview();
                this.setState();
            }
        }

        onNavSelectionChange(newValue?: NavSelection): void {
            if (newValue) {
                const selected = this.navSelectionToSelected(newValue);
                this.onSelectedChange(selected);
            }
        }

        navSelectionToSelected(selection: NavSelection): ISelectedState {
            return {
                drawer: selection.drawer,
                drawerId: selection.drawerId,
                containerId: selection.container && selection.container.id,
                containerType: selection.container && selection.container.type,
                documentId: selection.document && selection.document.id,
                document: selection.document ? 'document' : undefined,
            };
        }

        selectedToNavSelection(selected: ISelectedState): NavSelection {
            return {
                drawer: selected.drawer,
                drawerId: selected.drawerId,
                container: selected.containerId ? {id: selected.containerId, type: selected.containerType} : undefined,
                document: selected.documentId ? {id: selected.documentId, type: ItemType.Document} : undefined,
            };
        }

        /* Callback when close is clicked in preview */
        closePreview(): void {
            this.previewDocs = [];
            this.selected = {
                drawerId: this.selected.drawerId,
                containerType: this.dmsModels.toItemType(this.selected.containerType),
                containerId: this.selected.containerId,
                documentId: null,
                drawer: this.drawerParamToSelectedDrawer(this.selected.drawer),
            };
            const setNavSelection = false;
            this.setPreview();
            this.setState(setNavSelection);
        }

        onDocumentNav(event: {detail: {id: string}}): void {
            this.selected = {
                drawerId: this.selected.drawerId,
                containerType: this.dmsModels.toItemType(this.selected.containerType),
                containerId: this.selected.containerId,
                documentId: event.detail.id,
                drawer: this.drawerParamToSelectedDrawer(this.selected.drawer),
            };
            this.setPreview();
            this.setState();
        }

        setToolbarContainer(): void {
            if (this.selected.containerId) {
                this.toolbarContainer = {
                    itemType: this.selected.containerType === ItemType.Project ?
                        'Project' : 'Folder',
                    id: this.selected.containerId,
                };
            } else if (this.selected.drawerId &&
                (this.selected.drawer === FileDrawer.My ||
                    this.selected.drawer === FileDrawer.Firm)) {
                this.toolbarContainer = {
                    itemType: 'Folder',
                    id: this.selected.drawerId,
                };
            } else {
                this.toolbarContainer = {
                    itemType: 'Client',
                    id: this.selected.drawerId,
                };
            }
        }

        onDownloadModalClosed(): void {
            if (this.showDownloadModal) {
                this.$scope.$apply(() => {
                    this.showDownloadModal = false;
                    this.hideDocumentPreview = false;
                    this.closePreview();
                });
            }
        }

        getTabName(): string {
            return (this.selected.drawer + '-documents').toLowerCase();
        }
    }

    TreeViewController.$inject = inject;

    angular.module('onvio.documents').controller('treeNavigation', TreeViewController);

})((window as any).angular);
